import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { COPY_PA3 as T } from "../lib/pruebaGratis";

const ENLACE = "rounded-lg border border-blue-300 bg-white px-3 py-2 text-sm font-medium text-blue-700 hover:bg-blue-100";

export default function PruebaGratis() {
  const { user, puede, refrescarUsuario } = useAuth();
  const abierta = user?.prueba_clinicas_autoservicio === true && !user?.is_demo_session;
  const cid = user?.active_clinic_id;
  const [consulta, setConsulta] = useState(null);
  const [error, setError] = useState(false);
  const [enviando, setEnviando] = useState(false);
  useEffect(() => {
    setConsulta(null); setError(false);
    if (!abierta) return;
    let viva = true;
    api.get("/prueba-gratis").then(({ data }) => viva && setConsulta({ cid, data }))
      .catch(() => viva && setError(true));
    return () => { viva = false; };
  }, [abierta, cid]);
  if (!abierta) return null;
  const data = consulta?.cid === cid ? consulta.data : null;
  async function confirmar() {
    setEnviando(true); setError(false);
    try {
      const { data: nuevo } = await api.post("/prueba-gratis/confirmar");
      setConsulta({ cid, data: nuevo });
      await refrescarUsuario();
    } catch (err) {
      if (err.response?.status === 409 && err.response?.data?.code === "YA_ES_CLIENTE") {
        setConsulta({ cid, data: { ya_es_cliente: true, requiere_confirmacion: false } });
      } else { setError(true); }
    }
    finally { setEnviando(false); }
  }
  const estado = data?.estado;
  const yaEsCliente = data?.ya_es_cliente === true;
  const textos = yaEsCliente ? [T.clienteTitulo, T.clienteDetalle] :
    estado === "en_espera" ? [T.espera, T.esperaDetalle] :
    estado === "pendiente" ? [T.aprobada, T.aprobadaDetalle] :
      estado === "rechazada" ? [T.rechazada, T.rechazadaDetalle] :
        estado === "cancelada" && ["telefono_usado", "numero_usado", "numero_repetido", "numero_ya_uso_prueba"].includes(data.motivo_fin) ? [T.numeroUsado] :
          data?.requiere_confirmacion ? [T.confirmarTitulo, T.confirmarDetalle] : [];
  // Activa y terminada conservan íntegra la tarjeta y los textos aprobados de ConsumoSofi.
  if (!textos.length && !data?.requiere_confirmacion && !error) return null;
  return <section className="m-4 rounded-xl border border-blue-200 bg-blue-50 p-5" aria-live="polite" data-testid="prueba-pa3">
    {textos.map((t, i) => i === 0 ? <h2 key={t} className="font-bold">{t}</h2> : <p key={t}>{t}</p>)}
    {error && <p role="alert">{T.error}</p>}
    {!yaEsCliente && data?.requiere_confirmacion && puede("configuracion") && <button disabled={enviando} onClick={confirmar} className="mt-3 rounded-lg bg-blue-600 px-4 py-3 font-semibold text-white hover:bg-blue-700 disabled:opacity-60">{T.confirmar}</button>}
    {puede("configuracion") && <div className="mt-3 flex gap-4">
      {yaEsCliente ? <Link to="/app/onboarding" className={ENLACE}>{T.clienteContratar}</Link> :
        <><Link to="/app/doctores" className={ENLACE}>{T.medicos}</Link><Link to="/app/asistente" className={ENLACE}>{T.sofi}</Link></>}
    </div>}
  </section>;
}
